// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { IdentityQueries } from '../../../../types/server/modules/identity/queries';

export type * from '../../../../types/server/modules/identity/queries';

export const createQueries = ( requests: Requests ): IdentityQueries => ({
  IdentityMyCapabilities: ( params?, headers? ) => {
        return requests.get( `/identity/my-capabilities`, params, headers );
      },
  CustomRolesById: ( id, query, headers ) => { 
          return requests.get( `/custom-roles/${id}`, query, headers ); 
        },
  CustomRoles: ( params?, headers? ) => {
        return requests.get( `/custom-roles/:id?`, params, headers );
      },
  IdentityAuthUserSecurityMe: ( params?, headers? ) => {
        return requests.get( `/identity/auth-user-security/me`, params, headers );
      },
  IdentityAuthUserSecurity: ( params?, headers? ) => {
        return requests.get( `/identity/auth-user-security/:userId?`, params, headers );
      },
  IdentityAuthUserSecuritySearch: ( params?, headers? ) => {
        return requests.get( `/identity/auth-user-security-search/:search?`, params, headers );
      }
});
